const DailyMain: React.FC = () => <Outlet />;
export default DailyMain;
